export const PRODUCT_TABS = [
  {
    autobotID: 'DASH_TAB_HOTELS',
    name: 'HOTELS',
    tabText: 'Hotels',
    id: 'hotels'
  },
  {
    autobotID: 'DASH_TAB_FLIGHTS',
    name: 'FLIGHTS',
    tabText: 'Flights',
    id: 'flights'
  },
  {
    autobotID: 'DASH_TAB_HOTEL + FLIGHT',
    name: 'PACKAGES',
    tabText: 'Packages',
    id: 'vacations'
  },
  {
    autobotID: 'DASH_TAB_CARS',
    name: 'CARS',
    tabText: 'Cars',
    id: 'cars'
  },
  {
    autobotID: 'DASH_TAB_CRUISES',
    name: 'CRUISES',
    tabText: 'Cruises',
    id: 'cruises'
  }
] as const

export const PRODUCT_TABS_EXPERIMENT = [
  {
    autobotID: 'DASH_TAB_HOTELS',
    name: 'HOTELS',
    tabText: 'Hotels',
    id: 'hotels'
  },
  {
    autobotID: 'DASH_TAB_FLIGHTS',
    name: 'FLIGHTS',
    tabText: 'Flights',
    id: 'flights'
  },
  {
    autobotID: 'DASH_TAB_HOTEL + FLIGHT',
    name: 'PACKAGES',
    tabText: 'Packages',
    id: 'vacations'
  },
  {
    autobotID: 'DASH_TAB_CARS',
    name: 'CARS',
    tabText: 'Cars',
    id: 'cars'
  },
  {
    autobotID: 'DASH_TAB_CRUISES',
    name: 'CRUISES',
    tabText: 'Cruises',
    id: 'cruises'
  }
] as const

export const HEADERS = {
  hotels: {
    headline: 'Save more on your next hotel',
    mobileHeadline: 'Save more on your next hotel'
  },
  flights: {
    headline: 'Save more on your next flight',
    mobileHeadline: 'Save more on your next flight'
  },
  vacations: {
    headline: 'Save up to $625 on your hotel and flight',
    mobileHeadline: 'Save up to $625 on your hotel and flight'
  },
  cars: {
    headline: 'Save more on your next rental car',
    mobileHeadline: 'Save more on your next rental car'
  },
  cruises: {
    headline: 'Save more on your next cruise',
    mobileHeadline: 'Save more on your next cruise'
  }
}

export const AMENITIES = {
  AIRSHUTTL: 'Search Hotels with Airport Shuttles',
  CASINO: 'Search Hotels with Casinos',
  FBRKFST: 'Search Hotels with Free Breakfast',
  FINTRNT: 'Search Hotels with Free Internet',
  FITSPA: 'Search Hotels with Gyms',
  FPRKING: 'Search Hotels with Free Parking',
  INCLUSIVE: 'Search All Inclusive Hotels',
  KITCHEN: 'Search Hotels with Kitchens',
  PETALLOW: 'Search Pet Friendly Hotels',
  SPOOL: 'Search Hotels with Swimming Pools',
  RESTRNT: 'Search Hotels with Restaurants',
  SPA: 'Search Hotels with Spas'
} as const

export const searchHeaders = {
  hotels: 'Search Hotels',
  flights: 'Search Flights',
  cars: 'Search Cars',
  vacations: 'Search Packages',
  cruises: 'Search Cruises'
} as const

export const dialogHeadings = {
  hotels: 'Where to?',
  flights: 'Book your flight now',
  cars: 'Find the best rental car',
  vacations: 'Get a travel package deal',
  cruises: 'Discover your perfect cruise'
} as const

export const tabButtons = {
  hotels: 'Find Your Hotel',
  flights: 'Find Your Flight',
  cars: 'Find Your Car',
  vacations: 'Find Your Trip',
  cruises: 'Book Now'
}

export const tabIconUrls = {
  hotels:
    'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/hotels.svg',
  flights:
    'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/flights.svg',
  cars: 'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/cars.svg',
  vacations:
    'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/packages.svg',
  cruises:
    'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/cruises.svg'
} as const
